import * as KJUR from 'jsrsasign';

export const generateSignature = (meetingNumber, role) => {
    const sdkKey = 'BLjNAXZiQ3GRz3IKr6_owA';
    const sdkSecret = 'QvQQ0ykr9NQ6VcsSTKoc2xan4jpvfabx';
    const iat = Math.round(new Date().getTime() / 1000) - 30;
    const exp = iat + 60 * 60 * 2;
    const oHeader = { alg: 'HS256', typ: 'JWT' };
    const oPayload = {
        sdkKey: sdkKey,
        appKey: sdkKey,
        mn: meetingNumber,
        role: role,
        iat: iat,
        exp: exp,
        tokenExp: exp
    };

    const sHeader = JSON.stringify(oHeader);
    const sPayload = JSON.stringify(oPayload);
    const sdkJWT = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, sdkSecret);
    return { signature: sdkJWT };
};
